export class TaskModel {
  public id: string;
  public userId: number;
  public staffName: string;
  public type: TaskType;
  public linkId: number;
  public reportNo : string;
  public parentId: number;
  public isDone: boolean;
  public createdOn: string;
  public dateType: TaskDateType;
  public typeLable: string;
  public message : string;
  public icon : string;
  public link : string;
}


export enum TaskType {
  LeaveToApprove = 1,
  ExpenseToApprove = 2,
  ExpenseToCheck = 3,
  ExpenseToPay = 4,
  InspectionVerified = 5,
  InspectionConfirmed = 6,
  SplitInspectionBooking = 8,
  ScheduleInspection = 9,
  QuotationModify = 10,
  QuotationSent = 11,
  QuotationCustomerConfirmed = 12,
  QuotationCustomerReject = 13,
  QuotationToApprove = 7,
  QuotationPending=14,
  UpdateCustomerToFB=15,
  UpdateSupplierToFB = 16,
  UpdateFactoryToFB=17,
  UpdateProductToFB = 18,
  InspectionReportFilling =30,
  ShipmentToRelease = 31,
  ConfirmAudit = 32,
  ScheduleAudit  =33,
  AuditReportFilling =34,
  ShipmenttoDispatch =35,
  LabReceivedthesample =36,
  UploadLabReport =37,
  Labcustomerdecision =38
}

export class TaskResponse {
  public result: TaskResult;
  public data: Array<TaskModel>;
}

export enum TaskResult {
  Success = 1,
  NotFound = 2
}
export enum TaskDateType {
  Today = 1,
  Yesterday = 2,
  Older = 3
}
export class TaskMessage {

  constructor(t: TaskModel, m: string, l : string, i : string, p : string) {
    this.task = t;
    this.message = m; 
    this.link = l;
    this.iconName = i; 
    this.path = p;
  }
  public message: string;
  public task: TaskModel;
  public link: string;
  public iconName : string;
  public path : string;
}
export class TaskSearchRequest {
  public skip: number;
  public isDone?: boolean;
  public taskType?: TaskFilterType;
}
export enum TaskFilterType {
  Inspection = 1,
  Audit = 2,
  InspectionReport = 3,
  AuditReport = 4,
  Lab = 5
}